// src/components/ProgressBar.tsx
import React from 'react';

import styles from './UploadItem.module.css';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressContent}>
        {/* <div>
          <strong>Uploading …</strong>
        </div> */}
        <div className={styles.progressBar}>
          <div className={styles.progressBarFill} style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
